import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "../Screens/Home/Home";
import Layout from "./Layout/Layout";
import Pricing from "../Screens/Pricing/Pricing";
import FAQs from "../Screens/FAQs/FAQs";
import Blog from "../Screens/Blog/Blog";
import CDRWriting from "../Screens/Services/CDRWriting";
import CareerEpisodeWriting from "../Screens/Services/CareerEpisodeWriting";
import Stage2CompetencyClaim from "../Screens/Services/Stage2CompetencyClaim";
import CDRReviewingService from "../Screens/Services/CDRReviewingService";
import ACSRPLReportWriting from "../Screens/Services/ACSRPLReportWriting";
import KA02ReportWriting from "../Screens/Services/KA02ReportWriting";
import PlagiarismCheckingandRemoval from "../Screens/Services/PlagiarismCheckingandRemoval";
import Tutoring from "../Screens/Services/Tutoring";
import NERServices from "../Screens/Services/NERServices";
import IMLANZassessment from "../Screens/Services/IMLANZassessment";
import CDRANZSCO from "../Screens/Services/CDRANZSCO";
import RPLANZSCO from "../Screens/Services/RPLANZSCO";
import CDRSamples from "../Screens/Services/CDRSamples";
import One from "../Screens/Blog/Screens/One";
import Two from "../Screens/Blog/Screens/Two";
import Four from "../Screens/Blog/Screens/Four";
import Three from "../Screens/Blog/Screens/Three";

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/cdrsamples" element={<CDRSamples />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/faqs" element={<FAQs />} />
          {/* SERVICES  */}
          <Route path="/cdrwriting" element={<CDRWriting />} />
          <Route path="/careerepisodewriting" element={<CareerEpisodeWriting />} />
          <Route path="/stage2competencyclaim" element={<Stage2CompetencyClaim />} />
          <Route path="/cdrreviewingservice" element={<CDRReviewingService />} />
          <Route path="/acsrplreportwriting" element={<ACSRPLReportWriting />} />
          <Route path="/ka02rportwriting" element={<KA02ReportWriting />} />
          <Route path="/plagiarismcheckingandremoval" element={<PlagiarismCheckingandRemoval />} />
          <Route path="/tutoring" element={<Tutoring />} />
          <Route path="/nerservices" element={<NERServices />} />
          <Route path="/imlanzassessment" element={<IMLANZassessment />} />
          {/* ANZSCO  */}
          <Route path="/cdranzsco" element={<CDRANZSCO />} />
          <Route path="/rplanzsco" element={<RPLANZSCO />} />
          {/* BLOGS  */}
          <Route path="/blog/List-of-Courses-that-Helps-to-Migrate-Engineers-to-Australia-in-2023." element={<One />} />
          <Route path="/blog/Your-Complete-Guide-to-the-KA02-Knowledge-Assessment-(2024-Edition)" element={<Two />} />
          <Route path="/blog/How-can-you-get-an-Australian-Onshore-Visa?" element={<Three />} />
          <Route path="/blog/What-is-the-CDR-Writing-Process-for-Engineers-Australia?" element={<Four />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default App;
